/**
 *
 * Spinner
 *
 */

import PropTypes from 'prop-types';
import Wrapper from './Wrapper';

function Spinner({ inline = false, size = 20 }) {
  // eslint-disable-line react/prefer-stateless-function
  return (
    <Wrapper $inline={inline} $size={size}>
      <div id="loader-wrapper">
        <div id="loader"></div>
      </div>
    </Wrapper>
  );
}

Spinner.propTypes = {
  inline: PropTypes.bool,
  size: PropTypes.number
};

export default Spinner;
